export default () => {
    // summary type reports
    const default_summary_columns = ["avatar", "progress", "tasks_count", "extra", "total"];
    const default_flextime_columns = ["avatar", "flextime_period", "tasks_count", "flextime_expected", "flextime_office_time", 'flextime_office_agreed_time', 'flextime_office_percent', "total", "flextime_balance", "flextime_status", "flextime_credit"];

    // list type reports
    const default_task_columns = ["client", "title", "topic_id", "assignees", "is_extra", "is_important", "time", "date", "start", "due_date", "status"];
    const default_entries_columns = ["client", "title", "person_id", "topic_id", "time_period", "time", "start", "timeFeedback"];

    return {
        default_summary_columns,
        default_task_columns,
        default_entries_columns,
        default_flextime_columns
    };
};
